import React from 'react'
import { get } from 'lodash'
import PaymentModal from '../../../elements/Payment/PaymentModal'

function PaymentButton(props) {
  const { lines, amount, amountAccessor, clearSelection } = props

  const isAllowed = lines.filter((v) => {
    const sameCurrency = get(v, 'currency') === get(lines, '[0]currency')
    const sameCompany = get(v, 'company._id') === get(lines, '[0]company._id')
    const isConfirmed = get(v, 'status') === 'Confirmed'
    const isPositiveAmount = get(v, amountAccessor) > 0

    return sameCurrency && sameCompany && isConfirmed && isPositiveAmount
  })

  return (
    <PaymentModal
      {...{
        disabled: isAllowed.length !== lines.length,
        clearSelection:clearSelection,
        buttonTitle: 'Make Payment',
        companyID: get(lines, '[0].company._id'),
        currency: get(lines, '[0].currency'),
        description: `Payment For Invoices [${lines.map((i) => i.code).join(', ')}]`,
        amount: amount || lines.reduce((acc, v) => acc + get(v, amountAccessor, 0), 0),
        postURL: 'stripe/invoices',
        payload: {
          lineTitle: 'Invoice Lines',
          lines,
          columns: [
            { title: 'Title', dataIndex: 'title', key: 'title' },
            { title: 'Code', dataIndex: 'code', key: 'code' },
            { title: 'Amount', dataIndex: amountAccessor, key: amountAccessor },
          ],
        },
      }}
    />
  )
}

export default PaymentButton
